module.exports = __webpack_public_path__ + "img/icon_证书_B级赛事@2x.8d81617c.png";